// In order to be able to restrict values we need some sort of enumerable to compare to.
// We use the object because then we can use `keyof` to easily convert to string literal.
// The benefit is we get IDE and compile time checking, but runtime data binding is the issue,
// which is why we need both.
export const HeaderAlignmentKeys = { left: '', right: '', center: '' };
export type HeaderAlignment = keyof typeof HeaderAlignmentKeys;

export interface Header {
    title?: string;
    subtitle?: string;
    titleAlignment?: HeaderAlignment;
    subtitleAlignment?: HeaderAlignment;
    mobileTitleAlignment?: HeaderAlignment;
    mobileSubtitleAlignment?: HeaderAlignment;
    headerLinkAlignment?: HeaderAlignment;
    mobileHeaderLinkAlignment?: HeaderAlignment;
}
